import { useHistory } from 'react-router';
import { useState, useMemo } from 'react';
import { ContentTaskGq } from '../../../../../graphql/projects/models/ContentTaskGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import { getTaskUrl } from '../../Tables/ContentTaskTable/TaskUrl';

export interface SelectUrlInput {
  contentTask: ContentTaskGq;
  reload: () => Promise<unknown>;
  clientUrl: string;
}

export type SelectUrlBag = ReturnType<typeof useSelectUrl>;

export function useSelectUrl({ reload, contentTask, clientUrl }: SelectUrlInput) {
  const [evaluatedUrl, setEvaluatedUrl] = useState('');
  // const cleanedEvaluatedUrl = getTaskUrl(evaluatedUrl, clientUrl);

  const contentTaskQuery = projectsApiService.queries.useGetContentTasks(
    {
      filtering: {
        projectId: contentTask.projectId,
        tagFilters: [],
        actions: [],
        keywordFilters: [],
        approvedStatus: [],
        urlSearchTerm: '"' + evaluatedUrl + '"',
        statusCodes: [],
      },
      sorting: {},
      rowsPerPage: 10,
      page: 0,
    },
    { skip: !evaluatedUrl?.length }
  );
  const contentTasks = !evaluatedUrl?.length
    ? []
    : contentTaskQuery.contentTasks?.filter((ct) => ct.id !== contentTask.id) ?? [];

  const [updating, setUpdating] = useState(false);
  const moveMutation = projectsApiService.mutations.contentPlan.useAddTaskKeywords();
  const history = useHistory();
  const handleMove = (destinationTaskId: number) => {
    setUpdating(true);
    moveMutation({
      projectId: contentTask.projectId,
      destinationContentTaskId: destinationTaskId,
      sourceContentKeywordIds: contentTask.keywords.map((kw) => kw.id),
      destinationOrderKeywordIds: [],
      insertByVolumeOrder: true,
    })
      .then(() => reload())
      .then(() => {
        history.push(`/${contentTask.projectId}/content/${destinationTaskId}`);
      })
      .finally(() => {
        setUpdating(false);
        setEvaluatedUrl('');
      });
  };

  const renameOk =
    !contentTaskQuery.query?.loading && evaluatedUrl?.length && !contentTasks?.length;

  const renameMutation = projectsApiService.mutations.contentPlan.useUpdateTaskDetails();
  const handleRename = () => {
    setUpdating(true);
    return renameMutation({
      projectId: contentTask.projectId,
      taskId: contentTask.id,
      urlNew: evaluatedUrl,
    })
      .then(() => reload())
      .finally(() => {
        setUpdating(false);
        setEvaluatedUrl('');
      });
  };

  return useMemo(
    () => ({
      renameOk,
      evaluatedUrl,
      setEvaluatedUrl,
      contentTasks: contentTasks,
      updating,
      loading: !!contentTaskQuery?.query?.loading,
      handleMove,
      handleRename,
      nandleClose: () => setEvaluatedUrl(''),
    }),
    [
      renameOk,
      evaluatedUrl,
      updating,
      !!contentTaskQuery?.query?.loading,
      contentTasks,
      contentTask.id,
    ]
  );
}
